"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ReactDOM = __importStar(require("react-dom"));
const Modal_1 = __importDefault(require("./Modal"));
const ModalManager = {
    component: null,
    options: null,
    props: {},
    init(ReactComponent, props) {
        this.component = ReactComponent;
        this.props = props;
    },
    show(body) {
        const modalContainer = document.getElementById("shpID-lightbox");
        if (!modalContainer) {
            throw new Error("Modal Container is not found");
        }
        if (!this.component) {
            throw new Error("Parent Component is not initialized");
        }
        ReactDOM.unstable_renderSubtreeIntoContainer(this.component, React.createElement(Modal_1.default, Object.assign({ body: body }, this.props)), modalContainer);
    },
    close() {
        const elem = document.getElementById("shpID-lightbox");
        if (elem) {
            ReactDOM.unmountComponentAtNode(elem);
        }
    }
};
exports.default = ModalManager;
//# sourceMappingURL=ModalManager.js.map